import styled from 'styled-components';
import Select from 'react-select';
import { Image } from '@/shared/ui/image';

export const OptionsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 50%);
  gap: 2px;
  margin: 0 12px;
  border-radius: 12px;
  overflow: hidden;
  padding-bottom: 12px;
`;

export const OptionWrapper = styled.div`
  display: flex;
  gap: 8px;
  z-index: ${(props) => (props.$isSelected ? 1 : 0)};
  background: ${(props) => (props.$isSelected ? '#27262B' : '#3D3C41')};
  border-radius: ${(props) => (props.$isSelected ? '8px' : 'inherit')};
  justify-content: flex-start;
  padding: 8px;
  padding-right: 12px;
  position: relative;
  align-items: center;
  cursor: pointer;
  margin-bottom: 2px;
  padding: 8px;
  color: ${(props) => (props.$isSelected ? '#fff' : '#AFAFAF')};

  @media (max-width: 768px) {
    justify-content: space-between;
  }

  &:hover {
    background: #625a63;
    color: #edeff5;
    border-radius: 8px;
  }

  ${({ $haveDrawer, $isSelected }) =>
    $haveDrawer &&
    `
margin:0;
padding:20px 12px;
height:60px;
  border-radius:0;

`}
`;

export const SelectWrapper = styled.div`
  min-width: 140px;
  @media (max-width: 768px) {
    min-width: 100%;
  }
`;

export const CategoryText = styled.div`
  color: #afafaf;
  text-shadow: 0px 1px 1px rgba(18, 22, 32, 0.4);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
`;

export const TitleText = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  text-transform: capitalize;
`;

export const StyledSelect = styled(Select)`
  .react-select__control {
    border-radius: 8px;
    flex-basis: 140px;
    height: 48px;
    background: linear-gradient(90deg, #ff9500 0%, #ff5e00 100%);
    z-index: 0;
    padding: 6px 12px;
    overflow: hidden;
    cursor: pointer;

    @media (max-width: 768px) {
      height: 42px;
      justify-content: flex-start;
      padding: 0;
      background:
        linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%), #625a63;
    }
  }
  ${({ $searchFocused }) =>
    $searchFocused &&
    `
  .react-select__control {
   @media (max-width: 768px) {
            padding: 0 11px;

    }
  }
`}
  .react-select__indicators {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .react-select__control:hover {
    border-radius: 8px;
    opacity: 0.9;
    // box-shadow: 0px 0px 12px 0px #625A63 inset;
  }

  .react-select__control:active {
    border-radius: 8px;
    opacity: 0.9;
  }
  .react-select__indicator {
    position: absolute;
    right: 10px;
    top: 10px;
    display: none;
    @media (max-width: 768px) {
      top: 12px;
      right: 8px;
    }
  }
  .react-select__menu-list {
    padding: 6px;

    @media (max-width: 768px) {
      max-height: 100% !important;
    }
  }
  .react-select__menu {
    border-radius: 8px;
    margin-top: 4px;
    border-radius: 8px;
    width: 240px;
    overflow: hidden;
    background: #3d3c41;
    box-shadow: 0px 1px 1px 0px rgba(239, 241, 243, 0.08) inset;
    z-index: 100;
  }

  ${({ $searchFocused }) =>
    $searchFocused &&
    `
  .react-select__value-container {
    @media (max-width: 768px) {
      display: none;
    }
  }
`}
`;

export const ControlWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  z-index: 2;

  @media (max-width: 768px) {
    gap: 8px;
    padding: 8px;
  }
`;

export const ImageControlWrapper = styled.div`
  display: flex;
  img {
    filter: brightness(0) invert(1);
  }
`;
export const OptionText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  text-transform: capitalize;
`;

export const ImageOption = styled(Image)`
  position: relative;
  filter: ${(props) => props.$isActive && 'brightness(0) invert(.9)'};
`;

export const OptionCheck = styled.div`
  position: absolute;
  right: 12px;
  top: 14px;
`;

export const CategoryDrawerText = styled.div`
  color: #edeff5;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 24px */

  ${({ $haveDrawer }) =>
    $haveDrawer &&
    `
padding:0 16px;
padding-top:16px;
margin-bottom:32px;
`}
`;
export const OptionCount = styled.span`
  color: #afafaf;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-left: 4px;
`;

export const SearchOptionInput = styled.input`
  display: flex;
  padding: 8px 12px 8px 8px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border: none;
  background-color: #3d383f;
  width: 100%;
  padding-left: 40px;
  color: #afafaf;
  background-image: ${(props) =>
    props.$isHasValue
      ? 'url(/images/icons/search-icon-white.svg)'
      : 'url(/images/icons/search-icon.svg)'};
  background-repeat: no-repeat;
  background-position: 6px center;
  border-radius: 12px;

  @media (max-width: 768px) {
    height: 56px;
  }

  &::placeholder {
    color: #afafaf;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
  }

  ${({ $haveDrawer }) =>
    $haveDrawer &&
    `background-position: 14px center;
  padding-left: 48px;

    `}
`;

export const SearchOptionInputWrapper = styled.div`
  display: flex;
  padding: 6px 6px 0px 6px;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  padding-bottom: 6px;
  border-bottom: 1px solid rgba(65, 77, 107, 0.4);

  @media (max-width: 768px) {
    margin: 12px 12px;
    padding: 0;
    border: none;
    display: block;
  }
`;

export const NotFoundElement = styled.div`
  color: #afafaf;
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 120 %;
  padding: 24px 32px;
  ${({ $haveDrawer }) =>
    $haveDrawer &&
    `
  text-align:center;
  margin-top:auto;

    `}
`;
